<template>
  <div class="hello">
    <img src="../assets/grandiz-logo.png">
    <h2>Welcome to Harvest Analytics</h2>
      <v-btn round color="primary" @click="auth" >AUTHORIZE in Harvest</v-btn>
  </div>
</template>

<script>
  import {
    Api
  } from '../services';
  import Config from '../config'
  import queryString from 'query-string';
  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        subdomain: 'hat',
        client_id: Config.client_id,
        redirect_uri: Config.redirect_uri
      }
    },
    created() {
      let parsed = queryString.parse(location.search);
      if (parsed.code) {
        this.$router.push(`/auth?${location.search}`);
      }
    },
    methods: {
      auth() {
        let uri2 = `https://id.getharvest.com/oauth2/authorize?client_id=${this.client_id}&response_type=code&redirect_uri=${this.redirect_uri}`;
        console.log('uri', uri2)
        window.location = uri2;
        // return Api.Auth().signIn()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1,
  h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue